<template>
  <v-card class="rounded-lg pa-2 white  pb-8" flat>
    <v-card-title class="secondary--text">
      <v-spacer></v-spacer>
      <chart-export-btn :page-chart-id="chartId"></chart-export-btn>

    </v-card-title>

    <div
        class="secondary--text font-weight-bold"
        style="width: 100%; height: 40px; position: absolute; top: 52%; left: 0; margin-top: auto; line-height:19px; text-align: center; z-index: 999999999999999">
      <div>بیشترین کالای تعدیلی</div>
      <div class="grey--text" style="font-size: medium; margin-top: 10px"> از نظر {{adjustment_type_display}}</div>

    </div>
    <canvas :id="chartId">

    </canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";
export default {
  name: 'TotalAdjustmentGoodsChart',
  components: {ChartExportBtn},
  props: {
    adjustment_type: {
      default: 'ia'
    },
  },

  data() {
    return {
      chartResult: null,
      chartData: {
        type: "doughnut",
        data: {
          labels: ["کالا یک", "کالا دو", "کالا سه", "کالا چهار", "کالا پنج", "سایر"],
          datasets: [
            {
              data: [35, 25, 15, 10, 8, 7],
              backgroundColor: ["#43CED7", "#50CC89", "#FFC700", "#F1416C", '#7239E9', '#019EF6' ],
              borderWidth: 3,
              hoverBorderWidth:5,
              hoverBorderColor: '#FFFFFF',
            },
          ]
        },
        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          legend: {
            position: 'bottom'
          },
          cutoutPercentage: 70,
          responsive: true,
          plugins: {
            legend: {

              position: 'top',
            },
          }
        }
      },
    }
  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/totalAdjustmentWaresChartView/${this.adjustment_type}`),
        method: "get",
        success: data => {
          this.chartResult = data.results
          this.getData()
        }
      })
    },

    getData() {
      this.chartData.options.title.text = 'بیشترین کالای تعدیلی ' +
          'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name + ' بر اساس ' + this.adjustment_type_display
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []

      for (let ware of this.chartResult){
        this.chartData.data.labels.push(ware.title)
        this.chartData.data.datasets[0].data.push(ware.adjustment_count)

      }
      this.getChart()
    },
    getChart(){
      const ctx = document.getElementById(`${this.chartId}`);
      new Chart(ctx, this.chartData);
    }

  },
  mounted() {
    this.getChartFromApi()
  },
  computed: {
    chartId() {
      if (this.adjustment_type == 'ia') {
        return 'input-adjustment-goods-chart'
      }
      else {
        return 'output-adjustment-goods-chart'
      }
    },
    adjustment_type_display() {
      if (this.adjustment_type == 'ia') {
        return 'رسید'
      }
      else {
        return 'حواله'
      }
    },
  }
}
</script>